// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader_PageHeader__26oil","Section":"PageHeader_Section__3ADno","last-child":"PageHeader_last-child__2_L8Z","Item":"PageHeader_Item__39dcQ"};